import styled, {
  createGlobalStyle,
  css,
} from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  ${({ theme }) => css`
    *,
    ::after,
    ::before {
      box-sizing: border-box;
      outline: none;
    }

    html {
      line-height: 1.15;
      -webkit-text-size-adjust: 100%;
      -ms-text-size-adjust: 100%;
      -ms-overflow-style: scrollbar;
      -webkit-tap-highlight-color: transparent;
      scroll-behavior: smooth;
    }

    @keyframes pulse {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.25);
      }
      100% {
        transform: scale(1);
      }
    }

    article,
    aside,
    figcaption,
    figure,
    footer,
    header,
    hgroup,
    main,
    nav,
    section {
      display: block;
    }

    button {
      border: none;
      font-family: ${theme.font.montserrat};
    }

    body {
      padding: 0;
      margin: 0;
      font-size: 16px;
      line-height: 1.35;
      background: ${theme.colors.mainBg};
      color: ${theme.colors.black};

      ::-webkit-scrollbar {
        width: 8px;
      }

      ::-webkit-scrollbar-thumb {
        background: ${theme.colors.primary};
        border-radius: 10px;
      }
    }

    body,
    input,
    textarea {
      font-family: ${theme.font.roboto};
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-family: ${theme.font.roboto};
      margin-top: 0;
      margin-bottom: 0;
      font-weight: bold;
    }

    @media print {
      @page {
        size: A4;
        margin: 210mm !important;
      }

      header,
      .nav-menu,
      .menu,
      .no-print {
        display: none !important;
        padding: 0 !important;
        margin: 0 !important;
        height: 0 !important;
      }

      .rdw-editor-main {
        overflow: visible !important;
      }

      .editor-className {
        box-shadow: none !important;
        border-radius: 0 !important;
        border: none !important;
      }
    }
  `}
`

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  cursor: auto;

  z-index: -999;
`

export const Container = styled.div`
  ${({ theme }) => css`
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding-left: calc(${theme.grid.gutter} / 2);
    padding-right: calc(${theme.grid.gutter} / 2);
  `}
`
